import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Image from '@max/leez-image';
import Text from '@hfe/max-text';
import LinearGradient from '@hfe/max-linear-gradient';
import './Photo.scss';
import { getImage } from "../../utils/common";
function Photo(p) {
    return <View className="photo-container">
      <Image className="photo-img" source={getImage(p.img)} resizeMode={'cover'} borderRadius={10} heightAuto widthAuto/>
      {p.showTag && <View className="photo-tag-container">
        <Text className="photo-tag">{p.productTypeName}</Text>
      </View>}
      <LinearGradient x-if={p.bottomTag} className="photo-bottom-tag-container" start={{
            x: 0,
            y: 0
        }} end={{
            x: 1,
            y: 1
        }} colors={['#FFE1A3', '#FFC16A']}>
        <Text className="photo-bottom-tag">{p.bottomTag}</Text>
      </LinearGradient>
    </View>;
}
export default memo(Photo);
